// extracted by mini-css-extract-plugin
export default {"host":"MediaHeader_host__Ifze0"};